import { render, staticRenderFns } from "./passengers.vue?vue&type=template&id=38c25fa5&"
import script from "./passengers.vue?vue&type=script&lang=ts&"
export * from "./passengers.vue?vue&type=script&lang=ts&"
import style0 from "./passengers.vue?vue&type=style&index=0&id=38c25fa5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports